import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const baseUrl = process.env.NODE_ENV === "development"
  ? process.env.REACT_APP_BACKEND_LOCAL_API
  : process.env.REACT_APP_BACKEND_LIVE_API;

const Gateway = () => {
  const [RazorPayout, setRazorpayout] = useState(true);
  const [decentroPayout, setdecentropayout] = useState(true);
  const [settingId, setSettingId] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(baseUrl + "gatewaysettings/data");
        const data = res.data;
        setSettingId(data._id || "");
        setRazorpayout(data.RazorPayout === true || data.RazorPayout === "true");
        setdecentropayout(data.decentroPayout === true || data.decentroPayout === "true");
      } catch (error) {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to fetch gateway settings' });
      }
    };
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(baseUrl + "gatewaysettings", {
        settingId,
        RazorPayout,
        decentroPayout,
      });
      if (response.data.status === 'success') {
        Swal.fire({ icon: 'success', title: 'Success', text: 'Settings saved successfully' });
      } else {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Settings not saved' });
      }
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to submit settings' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <h4 className="text-uppercase font-weight-bold mb-1">Payment Gateway Settings</h4>
        <p className="page-subtitle">Enable or disable UPI and Bank payout.</p>
      </div>
      <div className="admin-card">
        <div className="admin-card-header">Payout Options</div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group col-md-4">
                <label>UPI Payout</label>
                <select
                  className="form-control"
                  value={String(RazorPayout)}
                  onChange={(e) => setRazorpayout(e.target.value === "true")}
                >
                  <option value="true">Enable</option>
                  <option value="false">Disable</option>
                </select>
              </div>
              <div className="form-group col-md-4">
                <label>Bank Payout</label>
                <select
                  className="form-control"
                  value={String(decentroPayout)}
                  onChange={(e) => setdecentropayout(e.target.value === "true")}
                >
                  <option value="true">Enable</option>
                  <option value="false">Disable</option>
                </select>
              </div>
            </div>
            <button type="submit" className="btn btn-success" disabled={loading}>
              {loading ? 'Saving...' : 'Save Settings'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Gateway;
